export default __webpack_public_path__ + "static/evolve_logo-bde9f4fef8ce8bf98dde50da880b1d93.png";